export const SET_ACTIVITIES = 'SET_ACTIVITIES';
export const SET_ACTIVITIES_LOADING = 'SET_ACTIVITIES_LOADING';
export const SET_ACTIVITY_DATA = 'SET_ACTIVITY_DATA';
export const CLEAR_ACTIVITY_DATA = 'CLEAR_ACTIVITY_DATA';
export const CLEAR_ACTIVITIES = 'CLEAR_ACTIVITIES';
export const SET_REPORT_ACTIVITIES = 'SET_REPORT_ACTIVITIES';
export const CLEAR_REPORT_ACTIVITIES = 'CLEAR_REPORT_ACTIVITIES';
